const __env = window.__env || {};

const { API_BASE_URL, APP_DEPLOY_ENV, APP_VERSION, SENTRY_DSN, SITE_URL } = __env;

export { API_BASE_URL, APP_DEPLOY_ENV, APP_VERSION, SENTRY_DSN, SITE_URL };
